/**
 * It's a generated file, preferable to extend this in external file
 */
import {TransportTypeName} from 'common/enums';
import * as yup from 'common/yup';
import {FileTransferVerifyType} from 'types/FileTransferVerifyType';
import {
   AbstractTransport,
   fileTransferVerifyTypeSchema,
   transportTypeSchema,
} from 'types/transport/Abstract/AbstractTransport';
import {transportTypeNameSchema} from 'types/transport/TransportTypeName';
import {TransportType} from 'types/TransportType';
import {SharepointServer} from './SharepointServer';

export const SharepointTransport = AbstractTransport.shape({
   server: SharepointServer,

   typeName: transportTypeNameSchema.default(TransportTypeName.SHAREPOINT),
   transportType: transportTypeSchema.default(TransportType.enum.SHAREPOINT),
   fileTransferVerifyType: fileTransferVerifyTypeSchema.default(FileTransferVerifyType.enum.SIZE),

   retainModifyDate: yup.bool(),
});
export type ISharepointTransport = yup.InferType<typeof SharepointTransport>;
